module.exports = __webpack_public_path__ + "static/img/c-info-thaipost.9f98c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/c-info-thaipost.png
// module id = 4h5I
// module chunks = 31